import type { ComponentPropsWithoutRef } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { RailbarContainer } from "./RailbarContainer";

export interface ContentProps extends ComponentPropsWithoutRef<"div"> {
  disableSidebar?: boolean;
  fullHeight?: boolean;
  fullWidth?: boolean;
  noPadding?: boolean;
}

export const Content = ({
  children,
  fullWidth,
  fullHeight = true,
  noPadding,
  ...props
}: ContentProps) => (
  <main
    aria-label={t("main_content")}
    {...props}
    className={classNames("standard-layout-v2__content bg-secondary", {
      "standard-layout-v2__content--full": fullWidth,
      "standard-layout-v2__content--no-padding": noPadding,
      "h-full": fullHeight,
    })}
  >
    <div
      className={classNames("bg-secondary", {
        "h-full": fullHeight,
      })}
    >
      {children}
    </div>
    <RailbarContainer id="rail-bar-content" />
  </main>
);
